module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-eight2.afafc93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-eight2.png
// module id = 83KI
// module chunks = 0